import React from 'react';
import ReactDOM from 'react-dom';

interface PortalModalProps {
  children: React.ReactNode;
}

export default function PortalModal({ children }: PortalModalProps) {
  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <div
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999999999999999999999999999999999,
    pointerEvents: 'none', // allow clicks to pass through
  }}
>
  {children}
</div>,
    document.body
  );
}
